import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../utils/commonUrl';
import Layout from '../components/Layout'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import AssessmentForm from "./forms/AssessmentForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchassestment} from "../redux/features/assestment.feature";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const Assestment = () => {
    const dispatch = useDispatch();
    const state = useSelector((state => state["assestment"]))
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [assessmentItem, setAssessmentItem] = useState({
        assestmentID: 0,
        assestmentName: "",
        weight:0,
        rca:0,
        active: true,
    })

    useEffect(() => {
        initFilters1();
        dispatch(fetchassestment())
    }, [])

    const onSubmit = async data => {
        try {
            setIsLoading(true)
            const url = BASE_URL + "/api/assestment";
            const response = await axios.post(url, data);
            setIsLoading(false)
            if (response.status === 200) {
                dispatch(fetchassestment())
                setAssessmentItem({
                    assestmentID: 0,
                    assestmentName: "",
                    weight:0,
                    rca:0,
                    active: true,
                })
                setModal(!modal)
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }


    }

    const onHide = () => {
        setModal(!modal)
        setAssessmentItem({
            assestmentID: 0,
            assestmentName: "",
            weight:0,
            rca:0,
            active: true,
        })
    }
    const editGridData = data => {
        setAssessmentItem({
            assestmentID: data.assestmentID,
            assestmentName: data.assestmentName,
            weight:data.weight,
            rca:data.rca,
            active: data.active,
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteQuarterItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }

    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'assestmentName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'weight': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'rca': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end




    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Assessment</button>
            </div>
        </div>
    );
    const footer = `In total there are ${state.assestment ? state.assestment.length : 0} assessment.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        // <DataTable value={user.users} header={header} footer={footer}>
        <DataTable value={state.assestment} header={header}
                   showGridlines
                   dataKey="assestmentID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['assestmentName', 'active']}
                   footer={footer} paginator rows={7} first={start}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="assestmentID" header="assestment ID" hidden={true}/>
            <Column field='assestmentName' header="Assessment Name"/>
            <Column field='weight' header="Weight"/>
            <Column field='rca' header="RCA"/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem'}}/>
        </DataTable>
    )

    return (
        <Layout>
            <AssessmentForm
                isLoading={isLoading}
                assestmentID={assessmentItem.assestmentID}                
                active={assessmentItem.active}
                assessmentName={assessmentItem.assestmentName}
                weight={assessmentItem.weight}
                rca={assessmentItem.rca}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}/>
            {Table}
        </Layout>
    )
}

export default Assestment